import {
  ScatterChart as MuiScatterChart,
  type ScatterChartProps as MuiScatterChartProps,
} from "@mui/x-charts/ScatterChart";
import { useTheme } from "@mui/material/styles";
import { useChartColors } from "./useChartColors";
import { getForestChartSx, forestLegendSlotProps } from "./chartSx";

export interface ScatterChartProps extends Omit<MuiScatterChartProps, "series"> {
  series?: MuiScatterChartProps["series"];
}

export function ScatterChart({ series, colors, ...props }: ScatterChartProps) {
  const theme = useTheme();
  const seriesColors = useChartColors(series?.length ?? 0);

  const modifiedSeries = series?.map((s) => ({
    ...s,
    highlightScope: s.highlightScope ?? { highlighted: "item", faded: "global" },
  }));

  return (
    <MuiScatterChart
      series={modifiedSeries ?? []}
      colors={colors ?? seriesColors}
      grid={{ horizontal: true, vertical: true }}
      slotProps={forestLegendSlotProps}
      sx={{
        ...getForestChartSx(theme),
        ...((props.sx as object) ?? {}),
      }}
      {...props}
    />
  );
}
